/*
<summary>
   This enum defines the tool_master.inspection_format values (Crimp Tool vs. User Created
   Inspection), used both by the Add/Edit Tool form and to route Tool Management's "Perform
   Inspection" action to the matching Equipment Inspection screen.
   Developer: Aashish Singh, Created Date: 25-Aug-2026
</summary>
*/
enum InspectionFormatEnum {
  CrimpingToolInspection = 0,
  UserCreated = 1,
}

export default InspectionFormatEnum;
